import { Component, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';
import { zopAnimations } from '@zopup/zop-ux-core';

@Component({
    selector: 'zop-auth-confirmation-required',
    templateUrl: './confirmation-required.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: zopAnimations,
    imports: [RouterLink]
})
export class AuthConfirmationRequiredComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
